import type { ExtendedVisionUser } from "@thalamos/vision-common";
import { isCurrentUserSupervisor } from "@thalamos/vision-common";

import { useNotifications } from "../../Context/NotificationContext.js";
import type { UserContextType } from "../../Context/UserContext.js";
import { TransferRequestedModal } from "../../modals/TransferRequested/TransferRequested.js";
import { PolicePresenceUpdatesNotification } from "./PolicePresenceUpdatesNotification/PolicePresenceUpdatesNotification.js";
import { S136FormRejectedNotification } from "./S136FormRejectedNotification/S136FormRejectedNotification.js";
import { TransferRejectedNotification } from "./TransferRejectedNotification/TransferRejectedNotification.js";

export const Notifications = ({
  user,
  refetchUser,
}: {
  user: ExtendedVisionUser;
  refetchUser: UserContextType["refetchUser"];
}) => {
  const {
    transferRequested,
    transferRejected,
    s136FormRejected,
    policePresenceUpdates,
  } = useNotifications();

  // TODO - (ASP-3896) this should be handled in the notification context so we only render the notifications in the officer context
  if (isCurrentUserSupervisor(user)) {
    // Supervisors do not see these notifications
    return null;
  }

  return (
    <>
      {transferRequested.isOpen && transferRequested.data && (
        <TransferRequestedModal
          user={user}
          notificationId={transferRequested.data.id}
          incidentWorkItemId={transferRequested.data.incidentWorkItemId}
          open={transferRequested.isOpen}
          close={transferRequested.close}
          refetchUser={refetchUser}
        />
      )}
      {transferRejected.isOpen && transferRejected.data && (
        <TransferRejectedNotification
          incidentWorkItemId={transferRejected.data.incidentWorkItemId}
          notificationId={transferRejected.data.id}
          close={transferRejected.close}
          refetchUser={refetchUser}
        />
      )}
      {s136FormRejected.isOpen && s136FormRejected.data && (
        <S136FormRejectedNotification
          incidentWorkItemId={s136FormRejected.data.incidentWorkItemId}
          notificationId={s136FormRejected.data.id}
          close={s136FormRejected.close}
        />
      )}
      {policePresenceUpdates.isOpen && policePresenceUpdates.data && (
        <PolicePresenceUpdatesNotification
          notification={policePresenceUpdates.data}
          close={policePresenceUpdates.close}
        />
      )}
    </>
  );
};
